console.log('js/collapsible.js -> v0.1.0');
$(() => {
	const collapse = (element, event) => {
		element.addClass('collapsed')
		element.parent().addClass('collapsed')
		element.siblings('.js-collapsible').addClass('hide')
	}

	const uncollapse = element => {
		element.removeClass('collapsed')
		element.parent().removeClass('collapsed')
		element.siblings('.js-collapsible').removeClass('hide')
	}

	// In order to reliably check if the page is mobile size,
	// this logic assumes that the page has an element with the class "columns"
	// that has a display value of "flex" on mobile and a different value on desktop.
	const check = () => {
		if($('.columns').css('display') === 'flex') {
			$('.js-collapser').each(function () {
				collapse($(this), false)
			})

			// hide all on mobile
			var $hideAllElement = $('.js-expand-hide-all');
			$hideAllElement.data('state', false)
			$hideAllElement.html("<i class=\"ebs-icon ebs-icon-plus\"></i> " + $hideAllElement.data("expand-text"))
		}
	}

	$("body").on('click', '.js-collapser', function(event) {
		if ($(this).hasClass('collapsed')) {
			uncollapse($(this))
		} else {
			collapse($(this), event)
		}
	});


	$(".js-expand-hide-all").on("click", function(e) {
		var $this = $(this);
		var $sections = $('.js-expand-all-parent').children('.collapsible');

		var dataState = $this.data('state')
		var state = parseInt($this.data('state'));
		var newstate = state ? 0 : 1;

		var icon = newstate ? "minus" : "plus";
		var text = newstate ? $this.data("hide-text") : $this.data("expand-text");

		// if state=0, show all the accordion divs within the same block (in this case, within the same section)
		if (newstate === 0) {
			$sections.each(function(){
				collapse($(this).find('.js-collapser'), false)
			});

		} else {
			$sections.each(function(){
				uncollapse($(this).find('.js-collapser'))
			});
		}

		$this.html("<i class=\"ebs-icon ebs-icon-" + icon + "\"></i> " + text);
		$this.data('state', newstate);

		return false;
	});

	check()

	//TODO: could we make the whole element clickable when it has the 'collapsed' class to uncollapse the text?
});

